import { createAction, props } from '@ngrx/store';

export const keyboardSave = createAction(
  '[Ngrx/Keyboard] Save',
  props<{ entity: string }>()
);

export const keyboardAdd = createAction(
  '[Ngrx/Keyboard] Add',
  props<{ entity: string }>()
);

export const keyboardOpenFilters = createAction(
  '[Ngrx/Keyboard] Open Filters',
  props<{ entity: string }>()
);

export const keyboardDelete = createAction(
  '[Ngrx/Keyboard] Delete',
  props<{ entity: string }>()
);

export const keyboardApplyFilters = createAction(
  '[Ngrx/Keyboard] Apply filters',
  props<{ entity: string }>()
);

export const keyboardResetFilters = createAction(
  '[Ngrx/Keyboard] Reset filters',
  props<{ entity: string }>()
);

export const showHelp = createAction(
  '[Ngrx/Keyboard] Show Help',
  props<{ show: boolean }>()
);
